export default __webpack_public_path__ + "static/media/sub-category-kitchensAndPopUps-kitchenSpace.3194283a.jpg";